import type { DroneInterval, DroneOctave } from '@/lib/practice/drone-keys';

const FIFTH_RATIO = 2 ** (7 / 12);
const OCTAVE_RATIO = 2;

const OCTAVE_MULTIPLIERS: Record<DroneOctave, number> = {
  low: 0.5,
  mid: 1,
  high: 2,
};

export function octaveMultiplier(octave: DroneOctave): number {
  return OCTAVE_MULTIPLIERS[octave];
}

export function intervalFrequencies(
  baseHz: number,
  interval: DroneInterval,
  octave: DroneOctave,
): number[] {
  const root = baseHz * octaveMultiplier(octave);
  const fifth = root * FIFTH_RATIO;
  const octaveAbove = root * OCTAVE_RATIO;

  switch (interval) {
    case 'single':
      return [root];
    case 'fifth':
      return [root, fifth];
    case 'oct5':
      return [root, fifth, octaveAbove];
  }
}
